// Verbose game-flow logging for the browser console. Off unless
// REACT_APP_DEBUG_LOGGING === 'true' (baked in at build time; docker-compose
// dev sets it true, prod leaves it false).
const ENABLED = process.env.REACT_APP_DEBUG_LOGGING === 'true';

// Palette names so console lines read "yellow right (3,4)->(9,4)" instead of
// raw hex — mirrors server/src/sockets/game/Game.js COLOR_NAMES.
export const COLOR_NAMES = {
  '#d94f2b': 'orange',
  '#2a63a8': 'blue',
  '#e0a325': 'yellow',
  '#2f9e6e': 'green',
};

export function logGame(...args) {
  if (!ENABLED) return;
  console.log(
    `%c[game] ${new Date().toISOString()}`,
    'color:#d94f2b;font-weight:bold',
    ...args,
  );
}
